export const localStorageIsRedirectionRequiredKey =
    'doesUserNeedsToBeRedirectedToOnboarding';
